module.exports = __webpack_public_path__ + "img/richarj.cc01795c.jpg";